import React, { useRef, useState } from 'react';
import { Loader, Dimmer, TableBody, TableCell, TableRow } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoCliente from '../../catalogos/catalogoCliente';
import axios from 'axios';


export const ModalImprimirRecibosReversados = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtTodosCliente = useRef();
  const txtPorCliente = useRef();
  const txtRif = useRef();
  const txtCbmrif = useRef();
  const txtNombre = useRef();
  const txtTodasFechas = useRef();
  const txtPorFechas = useRef();

  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [mostrar1, setMostrar1] = useState(false);
  const [activate, setActivate] = useState(false);
  const [actfecha, setActfecha] = useState(0);
  const [actcliente, setActcliente] = useState(0);
  const [clientvende, setClientvende] = useState('');
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tiporif, setTipofic] = useState('V');
  const [idclient, setIdclient] = useState('');

  const blanquear = () => {
    setActivate(false);
    setDesde('');
    setHasta('');
    setMostrar1(false);
    setClientvende('');
    setTipofic('V');
    setIdclient('');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {

      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
            txtDesde.current.focus()
          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
            txtHasta.current.focus()
          }
          sigue = false
        } else {
          imprimirReverso();
        }

      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
        if (txtRif.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRif.current.focus()
          sigue = false
        } else {
          imprimirReverso();
        }
      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
          txtPorFechas.current.focus()
          sigue = false
        } else if (txtRif.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRif.current.focus()
          sigue = false
        } else {
          imprimirReverso();
        }
      } else {
        imprimirReverso();
      }

    }

  }


  const imprimirReverso = () => {

    var reporte = "reportepagosreversados";
    let fechas = actfecha !== 0 ? ' and n.fecharegistro BETWEEN ' + "'" + '||quote_literal(' + "'" + desde + "'" + ')||' + "'" + ' and ' + "'" + '||quote_literal(' + "'" + hasta + "'" + ')' : '';
    let client = actcliente !== 0 ? fechas !== '' ? "'" + idclient : "'" + idclient + "'" : '';
    let valclient = actcliente !== 0 ? '' : "'";
    let condi = actcliente + actfecha > 0 ? client + valclient + fechas : "''";
    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }


  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const onChange = (e) => {
    if (e.target.name === 'nci') {
      setTipofic(e.target.value);
    } else if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde(moment(e.target.value).format('DD-MM-YYYY'));
      }
    } else if (e.target.name === 'hasta') {
      setHasta(moment(e.target.value).format('DD-MM-YYYY'));
    }

  }

  const onChekval = (e) => {
    if (e.target.name === 'fecha') {
      if (e.target.value === "1") {
        setActfecha(0);
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
        setDesde(moment(fechasistema).format('DD-MM-YYYY'));
        setHasta(moment(fechasistema).format('DD-MM-YYYY'));
      } else {
        setActfecha(1);
      }
    } else if (e.target.name === 'cliente') {
      if (e.target.value === "1") {
        setActcliente(0);
        txtRif.current.value = "";
        txtNombre.current.value = "";
      } else {
        setActcliente(1);
      }
    }
  }

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        selectResponsable(tiporif + e.target.value);
      }
    }
  };

  const handleAceptaCliente = (values) => {
    setMostrar1(false);
    if (clientvende === 'cliente') {
      txtCbmrif.current.value = values.rif.substring(0, 1);
      txtRif.current.value = values.rif.substring(1, 11);
      txtNombre.current.value = values.nombre;
      selectResponsable(values.rif);
    }
  };

  const selectResponsable = (id) => {

    let campos = '*';
    let nomtab = 'agente';
    let nomid = 'rif';
    let nomid2 = clientvende;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            if (clientvende === 'cliente') {
              txtNombre.current.value = response.data.nombre;
              txtRif.current.value = response.data.rif;
              setIdclient(' and n.idcliente = ' + response.data.idagente);
              btnAcepta.current.focus();
            }
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
            txtRif.current.value = '';
            txtNombre.current.value = '';
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const catalogoCliente = (ope) => (e) => {
    e.preventDefault();
    if (ope === 1) {
      setClientvende('cliente');
      setMostrar1(true);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtHasta.current.value = moment(fechasistema).format('YYYY-MM-DD');
        let desdec = moment(fechasistema).format('DD-MM-YYYY');
        let hastac = moment(fechasistema).format('DD-MM-YYYY');
        setDesde(desdec);
        setHasta(hastac);

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imprimir Recibos de PAGOS Reversados</h3></div>

        <a href='#' ref={btnSalir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Fecha:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="fecha" value="1" ref={txtTodasFechas} onChange={onChekval} id="fecha" type="radio" />
                  <label className="form-check-label" for="exampleRadi1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="fecha" value="2" ref={txtPorFechas} onChange={onChekval} id="fecha" type="radio" />
                  <label className="form-check-label" for="exampleRadi2">
                    Por Fecha
                  </label>
                </div>
              </div>

              <div className='col-7 row m-0'>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">DESDE:</label>
                    <input type="date" ref={txtDesde} disabled={actfecha === 0 ? true : false} name='desde' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">HASTA:</label>
                    <input type="date" ref={txtHasta} disabled={actfecha === 0 ? true : false} name='hasta' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Cliente:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="cliente" value="1" ref={txtTodosCliente} onChange={onChekval} id="cliente" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="cliente" value="2" ref={txtPorCliente} onChange={onChekval} id="cliente" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Cliente
                  </label>
                </div>
              </div>

              <div className='col-7 mr-auto px-0'>
                <div className="input-group input-group-sm col-7 px-1 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                  <select className="form-select col-3" ref={txtCbmrif} name='nci' onChange={onChange} aria-label="Default select example">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input type="text" ref={txtRif} disabled={actcliente === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={actcliente === 1 ? false : true} type="button" onClick={catalogoCliente(1)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 row m-0 py-3'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Cliente:</label>
                    <input type="text" ref={txtNombre} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset>

          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-11 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={props.ope !== 0 ? false : true} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>
      <CatalogoCliente
        show={mostrar1}
        nomid={clientvende}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaCliente}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/finanzas/imprimirRecibosReversado.js